// ------------------- Global ----------------

export const ERROR = {
  EMPTY_ERROR: 'Please fill out this field',
  LEADING_TRAILING_SPACES_ERROR:
    'This field cannot have leading or trailing spaces.',
  CREDIT_ERROR:
    'Ensure the entered amount does not exceed your remaining credits.',
  ZERO_CREDIT_ERROR: 'Your credit is 0; please contact the super admin.',
  ZERO_CREDIT_ERROR_SALES:
    'Your credit is 0; please contact the super admin or sales admin.',
  VALUE_MUST_BE_GREATER_THAN_ZERO: 'Value must be greater than zero.',
};

// export const INVALIDDOMAIN = [
//   'gmail.com',
//   'yahoo.com',
//   'hotmail.com',
//   'aol.com',
//   'hotmail.co.uk',
//   'hotmail.fr',
//   'msn.com',
//   'yahoo.fr',
//   'wanadoo.fr',
//   'orange.fr',
//   'comcast.net',
//   'yahoo.co.uk',
//   'yahoo.com.br',
//   'yahoo.co.in',
//   'live.com',
//   'rediffmail.com',
//   'free.fr',
//   'gmx.de',
//   'web.de',
//   'yandex.ru',
// ];

export const API_KEY = {
  SELECTION_PLACEHOLDER: 'API Keys',
  ADD_MORE_KEY: 'Add More Key',
  DOWNLOAD_BUTTON: 'Edit',
  GENERATE_KEY: 'Generate API Key',
  GENERATE_KEY_BUTTON: 'Generate Key',
};

export const INVALID_INPUT_MESSAGES = {
  FIRST_NAME: 'Invalid first name',
  LAST_NAME: 'Invalid last name',
  USER_NAME: 'Invalid user name',
  EMAIL: 'Please enter valid email',
  EMAIL_DOMAIN: 'Email domain is not allowed',
  CODE: 'Invalid code',
  PHONE_NO: 'Invalid Phone Number',
  ORGANIZATION: 'Invalid Organization Name',
  REFERRED_BY:
    'Invalid code! Please enter a 6 to 8 character code using only uppercase letters and numbers.',
  ROLE: 'Please select a role from dropdown',
  SALES_ADMIN: 'Please select a sales admin from dropdown',
  CONFIRM_PASSWORD: 'Passwords do not match',
  PASSWORD:
    'Must contain at least one number, one special character, one uppercase and lowercase letter, and at least 8 or more characters',
  FLOW_NAME: 'Invalid flow name',
  URL: 'Invalid url',
  DB_NAME: 'Invalid db name',
  CLIENT_ID: 'Invalid client Id',
  SECRET_KEY: 'Invalid secretKey',
  IP: 'Invalid IP Address',
  PORT: 'Invalid Port',
  COMPANY: 'Please enter valid company name',
};
export const INVALID_INPUT_REGEX = {
  NAME: /^[A-Za-z']{1,50}$/,
  NAME_WITH_NUMBER: /^[A-Za-z0-9'\s]{1,50}$/,
  FLOW_NAME: /^[A-Za-z0-9!@\-_&$<>*#%^?~+/{}():;|.,`"'=\s]{1,50}$/,
  PHONE_NO: /^[6-9]\d{9}$/,
  ORGANIZATION: /^(\d+|[^\w\s]+|)$/,
  REFERRAL_CODE: /^$|^[A-Z0-9]{6,8}$/,
  ONLY_OTP_DIGIT: /^\d$/,
  EMAIL_CAPITAL: /^[^A-Z]*$/,
  OTP_DIGIT: /^\d*$/,
  CODE_VERIFICATION: /^\d{6}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{8,}$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  URL: /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]{1,200}$/,
  ODOO_DB_NAME: /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]{1,200}$/,
  ODOO_PASSWORD: /^.+$/,
  IP_ADDRESS:
    /^(https?:\/\/)?\s*(localhost|(([0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}([0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])|(([0-9a-f]{1,4}:){7,7}[0-9a-f]{1,4}|([0-9a-f]{1,4}:){1,7}:|([0-9a-f]{1,4}:){1,6}:[0-9a-f]{1,4}|([0-9a-f]{1,4}:){1,5}(:[0-9a-f]{1,4}){1,2}|([0-9a-f]{1,4}:){1,4}(:[0-9a-f]{1,4}){1,3}|([0-9a-f]{1,4}:){1,3}(:[0-9a-f]{1,4}){1,4}|([0-9a-f]{1,4}:){1,2}(:[0-9a-f]{1,4}){1,5}|[0-9a-f]{1,4}:((:[0-9a-f]{1,4}){1,6})|:((:[0-9a-f]{1,4}){1,7}|:))(%[0-9a-zA-Z]{1,})?)\s*$/i,
  PORT: /^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|\d{1,4})$/,
  COMPANY: /^[a-zA-Z0-9&.,'’\-\s]{1,100}$/,
};

export const getHelperText = (
  errorFieldName,
  formDataFieldName,
  errors,
  formData,
) => {
  if (errors[errorFieldName]) {
    const fieldValue = formData[formDataFieldName].trim();
    const checkError = (errorMessage) =>
      fieldValue === '' ? ERROR.EMPTY_ERROR : errorMessage;
    switch (errorFieldName) {
      case 'firstName':
        return checkError(INVALID_INPUT_MESSAGES.FIRST_NAME);
      case 'lastName':
        return checkError(INVALID_INPUT_MESSAGES.LAST_NAME);
      case 'email':
        if (errors.email === 'Invalid email format') {
          return checkError(INVALID_INPUT_MESSAGES.EMAIL);
        }
        if (errors.email === 'Email domain is not allowed') {
          return checkError(INVALID_INPUT_MESSAGES.EMAIL_DOMAIN);
        }
        return checkError(INVALID_INPUT_MESSAGES.EMAIL);
      case 'phoneNo':
        return checkError(INVALID_INPUT_MESSAGES.PHONE_NO);
      case 'verificationCode':
        return checkError(INVALID_INPUT_MESSAGES.CODE);
      case 'password':
        return checkError(INVALID_INPUT_MESSAGES.PASSWORD);
      case 'newPassword':
        return checkError(INVALID_INPUT_MESSAGES.PASSWORD);
      case 'confirmPassword':
        return checkError(INVALID_INPUT_MESSAGES.CONFIRM_PASSWORD);
      case 'organizationName':
        return checkError(INVALID_INPUT_MESSAGES);
      case 'referralCodeBy':
        return checkError(INVALID_INPUT_MESSAGES.REFERRED_BY);
      case 'flowName':
        return checkError(INVALID_INPUT_MESSAGES.FLOW_NAME);
      case 'dbName':
        return checkError(INVALID_INPUT_MESSAGES.DB_NAME);
      case 'userName':
        return checkError(INVALID_INPUT_MESSAGES.USER_NAME);
      case 'url':
        return checkError(INVALID_INPUT_MESSAGES.URL);
      case 'ip_address':
        return checkError(INVALID_INPUT_MESSAGES.IP);
      case 'port':
        return checkError(INVALID_INPUT_MESSAGES.PORT);
      case 'company':
        return checkError(INVALID_INPUT_MESSAGES.COMPANY);
      case 'display':
        return checkError('');
      case 'displayName':
        return checkError('');
      case 'clientId':
        return checkError('');
      case 'secretKey':
        return checkError('');
      case 'odooPassword':
        return checkError('');
      case 'name':
        return checkError('');
      case 'price':
        return checkError(errors.price);
      case 'expiry':
        return checkError(errors.expiry);
      case 'credits':
        return checkError(errors?.credits);
      case 'description':
        return checkError('');
      default:
        return '';
    }
  }
  return '';
};

export const getHelperTextForEmptyField = (
  errorFieldName,
  formDataFieldName,
  errors,
  formData,
) => {
  if (errors[errorFieldName]) {
    const fieldValue = formData[formDataFieldName];
    const isEmpty = fieldValue.trim() === '';

    switch (errorFieldName) {
      case 'email':
      case 'password':
        if (isEmpty) {
          return ERROR.EMPTY_ERROR;
        }
        return '';
      default:
        return '';
    }
  }
  return '';
};

// ------------------- Authentication Pages ----------------

export const OCR_AUTHENTICATION_GRID = {
  TITLE: {
    HEAD: 'OCR-',
    TAIL: 'Service to Expense Account',
  },
  SUBTITLE:
    'Our OCR service offers a streamlined approach to managing expenses. Say goodbye to manual data entry and hello to efficiency.',
};

export const FILTER = {
  RESET_FILTER: 'Reset Filter',
  RESET_SORT: 'Reset Sort',
  APPLY_FILTER: 'Apply Filter',
};

export const HELP_SUPPORT = {
  MESSAGE:
    "We're currently working creating something fantastic.We'll be here soon",
  BUTTON: 'Contact Us',
};

export const OTP_SECTION = {
  HEADING: 'Verify Your Account',
  SUBTITLE: ' Enter the code below to confirm your identity',
  ERROR: 'Please fill fields with valid numbers',
};

export const REGISTER = {
  WELCOME_TEXT: {
    TITLE: 'Get Started With DocuTranscribe ',
    INFO: 'Enter the information for registering with us.',
  },
  TEXTFIELD_STEP_ONE: {
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email Address',
    PHONE_NO: 'Phone no',
  },
  CONTINUE_BUTTON: 'Continue',

  TEXTFIELD_STEP_TWO: {
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    ORGANIZATION_NAME: 'Organization Name',
    REFERRED_CODE: 'Referral Code',
  },
  SELECT_DROPDOWN_STEP_TWO: 'Country',
  TERMS_OF_SERVICE_AND_PRIVACY_POLICY: {
    TEXT1: 'I agree to the DocuTranscribe ',
    LINK1: 'Terms of Service ',
    TEXT2: 'and ',
    LINK2: 'Privacy Policy.',
  },
  CREATE_ACCOUNT_BUTTON: 'Create Your Account',
  LOGIN_LINK: {
    TEXT: 'Already have an account? ',
    LINK: 'Log In',
  },
};

export const LOGIN = {
  WELCOME_TEXT: {
    TITLE: 'Hey, hello ',
    INFO: 'Enter the information you entered while registering.',
  },
  TEXTFIELD: {
    EMAIL: 'Email Address',
    PASSWORD: 'Password',
  },
  REMEMBER_ME: 'Remember me',
  FORGOT_PASSWORD: 'Forgot password?',
  LOGIN_BUTTON: 'Login',
  SIGNUP_LINK: {
    TEXT: "Don't have an account? ",
    LINK: 'Sign Up',
  },
};

export const NAVBAR = {
  NO_NOTIFICATION: 'No notification',
  NOTIFICATION_DRAWER: 'View All',
  ASKING_MESSAGE_OF_VALIDATION: 'Do you want to review and validate the data?',
  ASKING_MESSAGE_OF_LOGOUT: 'Are You Sure You Want to Logout ?',
};

export const RESET_PASSWORD = {
  HEADER: 'Reset Password',
  INFO: {
    STEP1: 'Lost your password? Please enter your email address.',
    STEP2: 'Lost your password? Please enter code.',
    STEP3: 'Lost your password? Please enter your new password.',
  },

  TEXTFIELD_STEP_ONE: {
    EMAIL: 'Email Address',
  },
  TEXTFIELD_STEP_TWO: {
    CODE: 'Enter Code',
  },
  TEXTFIELD_STEP_THREE: {
    NEW_PASSWORD: 'New Password',
    CONFIRM_PASSWORD: 'Confirm Password',
  },

  SEND_CODE_BUTTON: 'Send Code',
  VERIFY_CODE_BUTTON: 'Verify',
  SUBMIT_BUTTON: 'Submit',

  RESET_PASS_LINK: {
    TEXT: 'Go Back to ',
    LINK: 'Log In',
  },
  RESEND_CODE_LINK: {
    TEXT: 'Resend Code',
  },
};

export const CHANGE_PASSWORD = {
  HEADER: 'Change Password',
  INFO: 'Change your password? Please enter your new password.',

  TEXTFIELD: {
    OLD_PASSWORD: 'Old Password',
    NEW_PASSWORD: 'New Password',
    CONFIRM_NEW_PASSWORD: 'Confirm New Password',
  },
  BUTTON: 'Change Password',
};

export const ADD_USER = {
  TEXTFIELD: {
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email Address',
    PHONE_NO: 'Phone no',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    ORGANIZATION_NAME: 'Organization Name',
    REFERRAD_CODE: 'Referral Code',
  },
  SELECT_DROPDOWN: 'Country',
  SUBMIT_BUTTON: 'Submit',
  FOOTER: '©2024 DocuTranscribe. All Right Reserved.',
};

// ------------------- Account Setting ----------------

export const PROFILE = {
  HEADING: 'My Account',
  CHANGE_PASSWORD: 'Change Password',
  MEMBER: 'Members',
  PLAN: 'My Plan',
  SUMMERY: 'Summary',
  INVITED_BY: 'Invited by',
  ADD_MORE_USERS: 'Add More Users',
  MY_CURRENT_PLAN: 'My Current Plan',
  PLAN_EXPIRY: 'please check your plan which dated expires.',
  BUTTON_TEXT: 'Change Password',
};

export const ADD_MEMBER = {
  CARD_TITLE: 'Add a Member to Aspire software',
  SUB_TITLE: 'Organizations allow you to invite team members and assign them.',
  EMAIL: 'Email',
  COUNTRY_DROPDOWN: ' Please fill out this field',
  ROLE: 'Role',
  INVITE_BUTTON: 'Invite Member',
};

export const UPLOAD_CATEGORY = {
  manual: 'Manual',
};

export const EXPORT_AUTH = {
  SUB_TITLE: 'Please Choose Your Account For Export',
  EXPORT_BUTTON: 'Export',
  SUB_TITLE_TALLY: 'Please Choose IP address',
};

export const INVOICE = {
  BUTTON_TEXT: 'Confirm Document',
  VERSION_BUTTON_TEXT: 'Edit this Version',
  VERSION_EDITING_TEXT: 'Export Document',
  CREATE_TAG_TYPO: 'Type to create a tag..',
  DOWNLOAD_ORIGINAL_FILE: 'Download Original Files',
  FILE_FORMATE_MESSAGE:
    'PDF, Word Documents, and images accepted. Documents will be intelligently classified into: Resumes, Receipts, Invoices etc.',
};

export const PAYMENT = {
  HEADING: 'Payment History',
  SUBTITLE: 'See history of your payment plan invoice',
  BUTTON_TEXT: 'Add Payment Detail',
  SELECT_TEXT: 'Filter by organization',
};

export const PAGE_NOT_FOUND = {
  MESSAGE: 'Oops...Something went wrong',
  BACK_TO_HOME: 'Back To Home',
  SUB_MESSAGE:
    "Seems like you're lost in space.Don't worry,we can help you find your way back",
  ALL_RIGHTS_RESERVED: '©2024 DocuTranscribe. All Right Reserved.',
};

export const ADD_PAYMENT = {
  CARD_TITLE: 'Add Payment Details',
  ORGANIZATION_NAME: 'Organization Name',
  AMOUNT: 'Amount',
  NO_OF_CREDITS: 'No. of Credits',
  STATUS: 'Status',
  DATE: 'Date',
  DURATION_START_DATE: 'Duration (Start Date)',
  DURATION_END_DATE: 'Duration (End Date)',
  UPLOAD_INVOICE: 'Upload Payment Invoice',
  BROWSER_FILE_BUTTON: 'Browse File',
  FILE_SELECTED: 'No File Selected',
  ADD_PAYMENT: 'Add Payment',
};

// ------------------- Setting of Fields ----------------

export const SETTING = {
  HEADING: 'Invoice Settings',
  DATA_FIELD_VALIDATION: 'At least one data field should be selected',
  MODEL: 'Model',
  ACCOUNT: 'Account',
  API_KEY: 'API Key',
  API_KEY_DESCRIPTION:
    'Use your API Key to authenticate with the AspireSofserv API Refer to the documentation for usage details',
  API_SECRET_KEY: {
    ASKING_MESSAGE: 'Are you sure you want to delete keys?',
    ALREADY_DOWNLOAD: 'For secret key contact : ',
    KEY_SELECTION: 'Kindly select any key from the provided options',
    EMPTY_FIELD: 'Client Name cannot be empty',
    SAME_VALUE: 'Current Value same as Existing value please change value .',
    INVALID_NAME: 'Invalid Key Name',
    VALID_LENGTH: 'KeyName is limited to 6 characters',
  },
  CREDENTIALS: 'Credentials',
  DOCUMENT_HANDLING: 'Duplicate Documents',
  ALLOW_MANAGERS: 'Allow Flow Configuration For Managers.',
  DOCUMENT_DETAILS_HANDLING: 'Duplicate Document Details',
  DOCUMENT_HANDLING_DESCRIPTION:
    'Determine what to do when an uploaded document is a duplicate of an existing document.',
  DOCUMENT_HANDLING_DESCRIPTION_FOR_USERS:
    'This is selected by your organization admin, you have no access to change it.',
  PROGRESS_DESCRIPTION: '490 of 500 credits remaining',
  PROGRESS_DATE: 'Expires April 25th, 2023',
  AUTO_VALIDATION: 'Auto Validation Threshold',
  AUTO_VALIDATION_DESCRIPTION:
    'Automatically validate data fields with confidence above this threshold',
  SLIDER_PERCENTAGE: '90%',
  NO_VALIDATION: 'No Auto Validation',
  DATA_FIELD: 'Data Fields',
  DATA_FIELD_DESCRIPTION: 'Select the fields that should be extracted',
  DATA_FIELD_DESCRIPTION_FOR_USER:
    'This fields are selected by your organization root-admin, you have no access to change it.',
  SECRET_KEY_DOWNLOAD_ALREADY: 'You Have Already Download It',
};

export const CHANGEPASSWORD = {
  CHANGE_PASSWORD: 'Change Password',
  OLD_PASSWORD: 'Old Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_NEW_PASSWORD: 'Confirm New Password',
  EMPTY_FIELD_VALIDATION: 'Please fill out this field',
  NEW_PASSWORD_INVALID_REGEX_VALIDATION:
    'Must contain at least one number , one special character , one uppercase and lowercase letter, and at least 8 or more characters',
};
export const SUBSCRIPTION_PLAN = {
  MAIN_HEADING: 'Subscription Plan',
  ASKING_MESSAGE_OF_DELETE_PLAN: 'Are you sure you want to delete this plan?',
  ASKING_MESSAGE_OF_DISCONTINUE_PLAN:
    'Are you sure you want to Discontinue this plan?',
  ASKING_MESSAGE_OF_CONTINUE_PLAN:
    'Are you sure you want to Continue this plan?',
};
// ------------------- Account Info ----------------

export const ACCOUNT_INFO = {
  MAIN_HEADING: 'Account Info',
  ACCOUNT: 'Account',
  PAYMENT_BUTTON: 'Make A Payment',
  MY_ACCOUNT: {
    HEADING: 'My Account',
    TFA_STATUS: {
      enabled: 'Two-factor-authentication is now active',
      disabled: 'Two-factor-authentication is now Inactive',
    },
  },
  BILLING_INFO: {
    HEADING: 'Billing Info',
    SUBSCRIPTION_DETAIL: 'You had paid monthly subscription',
    CHANGE_PASSWORD: 'Change Password',
    AUTH_TITLE: 'Two-Factor-Authentication',
    BILLING_CONTACT: 'My Account Details',
    BILLING_ACCOUNT_DETAILS: 'Billing Account Details',
    EDIT_DETAILS: 'Edit Details',
    CURRENT_PLAN_AND_PAYMENT_INFORMATION: 'Credit Available',
    CURRENT_PLAN_AND_PAYMENT_DETAILS: 'Current Plan & Payment Information',
    ACCOUNT: 'Account',
    PAYMENT_PAID_WITH: 'Payment Paid with',
    PAYMENT_DATE: 'Payment Date',
    DURATION: 'Duration',
    NO_UPDATE_MESSAGE: 'It seems you have not made any changes yet.',
    AVATAR_MESSAGE: 'Upload an avatar for your account',
    UPDATE_BUTTON: 'Update Detail',
    CANCEL_BUTTON: 'Cancel',
    SELECT_MANAGER: 'Add Billing Info',
    ASSIGN_WITH_DISCONTINUE_PLAN:
      'Do you want to assign this Discontinued Plan to the Organization?',
  },
  ACTIVITY_HISTORY: {
    HEADING: 'Activity History',
  },
  CREDITS_HISTORY: {
    HEADING: 'Credits History',
  },
  SCAN_HISTORY: {
    HEADING: 'Scan History',
  },
  SUPER_ADMIN_SCAN_HISTORY: {
    HEADING: 'Scan History',
  },
  EXPORT_REPORT: {
    HEADING: 'Export Report',
  },
  MEMBERS: {
    HEADING: 'Members',
    ADD_MORE: 'Invite More Users',
  },
  EDIT_DETAILS: {
    ASKING_MESSAGE_OF_DISCARD_CHANGES:
      'Are You Sure You Want to Discard Changes?',
    ASKING_MESSAGE_OF_UPDATE_DETAILS:
      'Are You Sure You Want to Update Details?',
  },
};

// ------------------- Super-admin-module ----------------

export const ADD_ORGANIZATIONS = {
  CARD_TITLE: 'Add an organization to DocuTranscribe',
  SUB_TITLE: 'Invite Admin of new organization to allow DocuTranscribe access.',
  EMAIL: 'Email',
  ORGANIZATION: 'Organization',
  INVITE_BUTTON: 'Invite',
  REFERRAL_CODE: 'Referral Code',
};

export const ADD_TO_TEAM_SA = {
  CARD_TITLE: 'Add a member to DocuTranscribe',
  SUB_TITLE: 'Invite member to DocuTranscribe.',
  EMAIL: 'Email',
  ROLE: 'Role',
  SALES_ADMIN: 'Sales Admin',
  INVITE_BUTTON: 'Invite',
};

export const UTILS = {
  EXPIRY_TIME: 'Invitation Expiry Time',
};

// .............invoice-management...........

export const ANNOTATION = {
  READ_ONLY_MODE: ' This is ReadOnly mode, click here to',
  REVIEW_DOCUMENT: 'Document reviewed',
  VALIDATION_MESSAGE: {
    OVERRIDE_VALUE:
      'This Field is already exist, This action will override the previous value.',
    EXISTING_VALUE: 'This Field is already exist for  product',
    ANOTHER_SELECTION: 'Please select another from list.',
  },
  INVOICE_MESSAGE: {
    VALIDATION_MESSAGE:
      'No dataFields selected, please select some dataFields.',
  },
  INVOICE_ANNOTATION_MESSAGE: {
    VALIDATION_MESSAGE:
      'No DataFields Selected, Please Select Some DataFields From',
    EXPORT_VALIDATION_MESSAGE:
      'Cannot export the data for newly created Version',
    SELECT_VERSION_VALIDATION_MESSAGE:
      'Please select version or Add new version',
    NO_CHANGES_DETECTED: 'No changes detected',
    SELECT_DATA_FIELD_VALIDATION: 'Please select data field.',
    NO_BOUNDING_BOX: "This value doesn't contain bounding box.",
  },
  CONFORM_DOCUMENT: {
    SAVE_CHANGES_EXISTING_VERSION:
      'Are You Sure You Want to save changes in your existing version ?',
  },
};
export const UPLOAD = {
  CHOOSE_FILES: 'Choose Files',
  UPLOAD: 'Upload',
};

export const exportQB = {
  scope: 'com.intuit.quickbooks.accounting openid profile email',
  invoiceNotValidated: 'Document is not validated yet',
  randomStringForQB:
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
  invoiceCreationSuccess: 'Document is exported successfully in your account',
  invoiceCreationFailed: 'Failed to export document',
};

export const INVOICE_FLOW = {
  FLOW_CONFIGURATION: 'Please Configure The Flow First.',
  NO_FLOWS: 'No flows found.',
  NO_MICROSOFT_NODE: 'No Microsoft Nodes are Connected',
};

export const REFER_A_FRIEND = {
  REFER_A_FRIEND: 'Refer a Friend',
  REFERRAL_CODE: 'Referral Code',
  EMAIL_ID: 'Email Id',
  SEND: 'Send',
  EMAIL_REQUIRED: 'Email is required.*',
};
